module.exports = __webpack_public_path__ + "static/media/5-Diamond.69a1f6ae.svg";